var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-full-wrapper',{ref:"wrapper",staticClass:"app-modal-wrapper",class:{
    bottom: _vm.position === 'bottom',
  },attrs:{"destroyOnClose":_vm.$attrs.destroyOnClose,"blur":_vm.$attrs.blur},on:{"click":function($event){return _vm.close(_vm.MODAL_CLOSE_BY_WRAPPER)},"opened":function($event){return _vm.$emit('opened', this)},"closed":function($event){return _vm.$emit('closed', this)}}},[_c('div',{staticClass:"app-modal",class:{ 'no-padding': _vm.noPadding }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }